import { checkStatus, json, FileAPI } from '@drifthq/dapper'

export const uploadFile = (file) => {
  const data = new FormData()
  data.append('file', file)
    return FileAPI
    .post('/upload', data, {file:true})
    .then(checkStatus)
    .then(json)
}


// WEBPACK FOOTER //
// ./src/modules/file/api.js